// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toast-modal-header-close-button[data-v-314405aa]{cursor:pointer;position:absolute;top:.4rem;right:-.8rem}@media (min-width:1024px){.toast-modal-header-close-button[data-v-314405aa]{top:.4rem;right:-1.8rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
